import {post} from "../utils";

export default host => (albumId) => post(`${host}/albums/${albumId}/unshare`, JSON.stringify({}))
  .then(response => response.json())
  .then(json => json.data)
